import { render, staticRenderFns } from "./TabelaFollowUps.vue?vue&type=template&id=d422e3f6&scoped=true"
import script from "./TabelaFollowUps.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaFollowUps.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaFollowUps.vue?vue&type=style&index=0&id=d422e3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d422e3f6",
  null
  
)

export default component.exports